<template>
    <div>
        <transition appear name="loading-bar">
            <loading-bar v-show="pending" />
        </transition>

        <b-card-body v-if="!pending && !items.length">
            <no-results-found class="mb-0"/>
        </b-card-body>

        <b-card
            v-for="(report, date) in items"
            :key="date"
            :header="$moment(date).format('ll')"
            class="mb-3"
        >
            <b-card
                v-if="report.weather"
                :title="$t('Weather')"
            >
                <project-weather-table :items="report.weather" />
            </b-card>

            <b-card
                v-if="report.services"
                :title="$t('Services')"
            >
                <project-completed-services-table :items="report.services" />
            </b-card>

            <b-card
                v-if="report.disabilities"
                :title="$t('Disabilities')"
            >
                <project-dropped-services-table :items="report.disabilities" />
            </b-card>

        </b-card>
    </div>
</template>

<script>

    import fetchData from "@/mixins/fetchData";
    import ProjectWeatherTable from "@/components/projects/ProjectWeatherTable";
    import ProjectCompletedServicesTable from "@/components/projects/ProjectCompletedServicesTable";
    import ProjectDroppedServicesTable from "@/components/projects/ProjectDroppedDisabilitiesTable";

    export default {
        name: 'ProjectConstructionReportTab',
        components: {
            ProjectDroppedServicesTable,
            ProjectCompletedServicesTable,
            ProjectWeatherTable
        },
        mixins: [fetchData],
        props: {
            projectId: {
                type: [String, Number],
                required: true,
            },
        },

        data() {
            return {
                fields: ['created_at', 'max_temp', 'min_temp', 'wind_speed']
            }
        },

        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/construction-reports`;
            },
        },
    };
</script>

<style scoped>
    .card + .card {
        margin-top: 1rem;
    }
</style>
